import React from "react";
import { AppPill } from "../common/appShell";

export default function NameSyncStatus({ resource }) {
  const status = resource?.nameSyncStatus || (resource?.queuedName ? "pending" : "synced");
  if (status !== "pending" && status !== "failed") return null;

  const failed = status === "failed";
  const explanation = failed
    ? "The device rejected this name. Edit the name to try again."
    : "Name saved in CMP and awaiting confirmation from the device.";
  const confirmedName = resource?.lastKnownName;

  return (
    <span title={`${explanation}${confirmedName ? ` Last confirmed name: ${confirmedName}.` : ""}`}>
      {" "}
      <AppPill tone={failed ? "danger" : "warning"}>
        {failed ? "Sync failed" : "Pending sync"}
      </AppPill>
    </span>
  );
}
